import { React } from "react"
import { Grid, useTheme, useMediaQuery } from "@mui/material"
import { Switch } from "@mui/material"

import useStyles, { FunctionBoxInputsMedStyles, FunctionBoxInputsPhoneStyles, FunctionBoxInputsStyles } from "./styles/VisitorStyles"

/* Component that defines the form area to (input) toggle switches for the relevant
    setup requirements for the specified visit. */
function FunctionsBox({ visitInfoObj, setVisitInfoObj }) {
    const theme = useTheme()

    // constants for conditional styling adjustments due to screen size (px)
    const isMediumScreen = useMediaQuery(theme.breakpoints.down("960"))
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("601"))

    /* Handler, to update state, for changes to the toggle on switches */
    const handleOnChange = (event, functionName) => {
        setVisitInfoObj({
            ...visitInfoObj,
            functionStatus: {
                ...visitInfoObj.functionStatus,
                [functionName]: event.target.checked
            }
        })
    }

    return (
        <>
            {/* Factory Tour function toggle switch component */}
            <Grid
                item
                align="flex-start"
                size={{xs: 5, sm: 9, md: 9}}
                sx={
                    isMediumScreen
                        ? isPhoneScreen
                            ? FunctionBoxInputsPhoneStyles
                            : FunctionBoxInputsMedStyles
                        : FunctionBoxInputsStyles
                }
            >
                CAMPUS TOUR
            </Grid>
            <Grid item size={{xs: 2, sm: 1, md: 2}}>
                <Switch
                    size="small"
                    color="warning"
                    checked={visitInfoObj.functionStatus.factory}
                    onChange={(event) => handleOnChange(event, "factory")}
                />
            </Grid>
            {/* Breakfast function toggle switch component */}
            <Grid
                item
                align="flex-start"
                size={{xs: 3, sm: 9, md: 9}}
                sx={
                    isMediumScreen
                        ? isPhoneScreen
                            ? FunctionBoxInputsPhoneStyles
                            : FunctionBoxInputsMedStyles
                        : FunctionBoxInputsStyles
                }
            >
                BREAKFAST
            </Grid>
            <Grid item size={{xs: 2, sm: 1, md: 2}}>
                <Switch
                    size="small"
                    color="warning"
                    checked={visitInfoObj.functionStatus.breakfast}
                    onChange={(event) => handleOnChange(event, "breakfast")}
                />
            </Grid>
            {/* Welcome Board function toggle switch component */}
            {isPhoneScreen && (
                <>
                    <Grid
                        item
                        align="flex-start"
                        size={{xs: 5, sm: 9, md: 9}}
                        sx={
                            isMediumScreen
                                ? isPhoneScreen
                                    ? FunctionBoxInputsPhoneStyles
                                    : FunctionBoxInputsMedStyles
                                : FunctionBoxInputsStyles
                        }
                    >
                        WELCOME BOARD
                    </Grid>
                    <Grid item size={{xs: 2, sm: 1, md: 2}}>
                        <Switch
                            size="small"
                            color="warning"
                            checked={visitInfoObj.functionStatus.welcome}
                            onChange={(event) =>
                                handleOnChange(event, "welcome")
                            }
                        />
                    </Grid>
                </>
            )}
            {/* Lunch function toggle switch component */}
            {!isPhoneScreen && (
                <>
                    <Grid
                        item
                        align="flex-start"
                        size={9}
                        sx={
                            isMediumScreen
                                ? FunctionBoxInputsMedStyles
                                : FunctionBoxInputsStyles
                        }
                    >
                        LUNCH
                    </Grid>

                    <Grid item size={{sm: 1, md: 2}}>
                        <Switch
                            size="small"
                            color="warning"
                            checked={visitInfoObj.functionStatus.lunch}
                            onChange={(event) => handleOnChange(event, "lunch")}
                        />
                    </Grid>
                </>
            )}
            {/* Welcome Board function toggle switch component */}
            {!isPhoneScreen && (
                <>
                    <Grid
                        item
                        align="flex-start"
                        size={9}
                        sx={
                            isMediumScreen
                                ? FunctionBoxInputsMedStyles
                                : FunctionBoxInputsStyles
                        }
                    >
                        WELCOME BOARD
                    </Grid>
                    <Grid item size={{xs: 1, sm: 1, md: 2}}>
                        <Switch
                            size="small"
                            color="warning"
                            checked={visitInfoObj.functionStatus.welcome}
                            onChange={(event) =>
                                handleOnChange(event, "welcome")
                            }
                        />
                    </Grid>
                </>
            )}
            {/* Lunch function toggle switch component */}
            {isPhoneScreen && (
                <>
                    <Grid
                        item
                        align="flex-start"
                        size={{xs: 3, sm: 9, md: 9}}
                        sx={
                            isMediumScreen
                                ? isPhoneScreen
                                    ? FunctionBoxInputsPhoneStyles
                                    : FunctionBoxInputsMedStyles
                                : FunctionBoxInputsStyles
                        }
                    >
                        LUNCH
                    </Grid>
                    <Grid item size={{xs: 2, sm: 1, md: 2}}>
                        <Switch
                            size="small"
                            color="warning"
                            checked={visitInfoObj.functionStatus.lunch}
                            onChange={(event) => handleOnChange(event, "lunch")}
                            // sx={FunctionLunch}
                        />
                    </Grid>
                </>
            )}
        </>
    )
}

export default FunctionsBox
